import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Subject, takeUntil } from 'rxjs';
import * as fromAuthStore from 'src/app/auth/store';

@Component({
  selector: 'app-auth-check-mail',
  templateUrl: './auth-check-mail.component.html',
  styleUrls: ['./auth-check-mail.component.scss'],
})
export class AuthCheckMailComponent implements OnInit, OnDestroy {
  @Input()
  type: string;

  destroyed$ = new Subject<boolean>();

  timer: any;
  timerValue: number = 59;
  confirmationEmail: string | undefined;

  constructor(
    private router: Router,
    private authStore: Store<fromAuthStore.State>
  ) {}

  ngOnInit(): void {
    this.authStore
      .select(fromAuthStore.getConfirmationEmail)
      .pipe(
        takeUntil(this.destroyed$),
        map((email) => {
          this.confirmationEmail = email;
          return email;
        })
      )
      .subscribe();
    this.timer = setInterval(() => {
      this.timerValue--;
      if (this.timerValue === 1) {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  sendEmailAgain() {
    if (this.type === 'password') {
      this.authStore.dispatch(
        new fromAuthStore.RecoverPassword({ email: this.confirmationEmail })
      );
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
